/**
 * On mobile, a color picker with a dozen swatches pushes the rest of the
 * product form (size, quantity, add to cart) well below the fold. Show only
 * the first few and let shoppers reveal the rest on request instead.
 */
(function () {
  var VISIBLE_LIMIT = 6;
  var expandedFormIds = {};

  function formIdForWrapper(wrapper) {
    var input = wrapper.querySelector("input[form]");
    return input ? input.getAttribute("form") : null;
  }

  function expand(wrapper, button) {
    wrapper.classList.add("color-swatches--expanded");
    if (button) button.remove();

    var formId = formIdForWrapper(wrapper);
    if (formId) expandedFormIds[formId] = true;
  }

  function setUpWrapper(wrapper) {
    var swatchCount = wrapper.querySelectorAll(".color-swatch").length;
    if (swatchCount <= VISIBLE_LIMIT) return;

    var formId = formIdForWrapper(wrapper);
    if (formId && expandedFormIds[formId]) {
      wrapper.classList.add("color-swatches--expanded");
      return;
    }

    if (
      wrapper.nextElementSibling &&
      wrapper.nextElementSibling.classList.contains("swatch-see-more")
    ) {
      return;
    }

    var hiddenCount = swatchCount - VISIBLE_LIMIT;
    var button = document.createElement("button");
    button.type = "button";
    button.className = "swatch-see-more";
    button.textContent =
      "See " + hiddenCount + " more " + (hiddenCount === 1 ? "color" : "colors");
    button.addEventListener("click", function () {
      expand(wrapper, button);
    });

    wrapper.insertAdjacentElement("afterend", button);
  }

  function initAll() {
    document
      .querySelectorAll(".form-options-wrapper.color-swatches")
      .forEach(setUpWrapper);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  if (typeof webvista !== "undefined" && webvista.subscribe) {
    webvista.subscribe(PUB_SUB_EVENTS.variantChange, initAll);
  }
})();
